import { ref, nextTick } from '@nuxtjs/composition-api';
const isPrebidLoaded = ref(false);

export const initializePrebid = (adTags, adConfig) => {
  if (!isPrebidLoaded.value) {
    adTags.script.push({
      hid: 'prebid',
      src: '/scripts/prebid9.40.0.js',
      async: true,
      callback: () => {
        isPrebidLoaded.value = true;
      },
    });
    if (process.client) {
      nextTick(() => {
        window.pbjs.que.push(function () {
          window.pbjs.bidderSettings = {
            standard: {
              storageAllowed: true,
            },
          };
          window.pbjs.addAdUnits(adConfig.value.prebidUnits);
          window.pbjs.setConfig({
            paapi: {
              enabled: true,
              defaultForSlots: 1,
              bidders: ['rtbhouse'],
              gpt: {
                autoconfig: false,
              },
            },
            priceGranularity: 'high',
            currency: {
              adServerCurrency: 'TRY',
              granularityMultiplier: 1,
              defaultRates: { USD: { TRY: 38 }, EUR: { TRY: 43 } },
            },
            userSync: {
              userIds: [
                {
                  name: 'id5Id',
                  params: {
                    partner: 1291,
                  },
                  storage: {
                    type: 'html5',
                    name: 'id5id',
                    expires: 90,
                    refreshInSeconds: 8 * 3600,
                  },
                },
                {
                  name: 'pubCommonId',
                  storage: {
                    type: 'cookie',
                    name: '_pubcid',
                    expires: 60,
                  },
                },
              ],
              filterSettings: {
                iframe: {
                  bidders: '*',
                  filter: 'include',
                },
              },
              iframeEnabled: true,
              auctionDelay: 50,
              syncEnabled: true,
              syncDelay: 3000, // 3 seconds after the first auction
            },
          });
          window.pbjs.setBidderConfig({
            bidders: ['rtbhouse'],
            config: {
              fledgeEnabled: true,
              defaultForSlots: 1,
            },
          });
        });
      });
    }
  }
};
